import { AtIcon } from './AtIcon';

/**
 * author: Google
 * id 9FC24609-9C8B-4DBA-A473-F5EFAFCC90DF
 * name at
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/at.svg
 * tags
 */
export const AlternateEmailIcon = AtIcon;
export default AlternateEmailIcon